import * as qs from "query-string";

export function paramsSerializer(params) {
  return qs.stringify(params, { arrayFormat: "bracket", encode: false });
}
